const documentUrl = "https://docs.google.com/document/d/e/2PACX-1vTYrWCGZ8oLZBtgl-R2mRwCE6FDG6DQbB6E_fQQhwFKsN2pCtEedEUNLRrpaWx7dZZmkgbmpzEHkBgQ/pub";
const basePath = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

export default function PrivacyPage() {
  return (
    <main className="legal-page">
      <nav className="legal-nav"><a className="brand" href={`${basePath}/`}><span>N</span><b>Naon<small>3D Platform</small></b></a></nav>
      <article className="legal-content legal-document-page">
        <p className="eyebrow">PRIVACY POLICY</p>
        <h1>NModeler 개인정보처리방침</h1>
        <p className="legal-meta">Google 문서의 최신 게시 내용을 표시합니다.</p>
        <p><a href={documentUrl} target="_blank" rel="noreferrer">Google 문서에서 열기</a> · <a href={`${basePath}/privacy/nscanner`}>NScanner 개인정보처리방침</a></p>
        <iframe className="legal-document" src={`${documentUrl}?embedded=true`} title="NModeler 개인정보처리방침" />
      </article>
    </main>
  );
}
